// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2_ogY","header":"ClearentDisclaimer_header__2ikG8","inner":"ClearentDisclaimer_inner__1iv8c"};